import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';

import { AppSettings } from '../../common/app.settings';
import { ErrorHandler } from '../../common/errorHandler';
import { QuestionService } from '../../services/question.service';
import { Question } from '../../models/question.model';
import { ResultCode } from '../../enums/resultcode.enum';
import { QuestionGroupService } from '../../services/question.group.service';
import { QuestionGroup } from '../../models/question.group.model';
import { FileImportModel } from '../../models/file.import.model';

@Component({
    selector: 'question-detail',
    templateUrl: './question-detail.component.html',
    styleUrls: ['./question-detail.component.css'],
    providers: [QuestionService, QuestionGroupService, ErrorHandler, FormBuilder]
})
export class QuestionDetailComponent implements OnInit {
    question: Question;
    zoomedImageSrc: string;
    smallImageSrc: string;
    isDataAvailable = false;
    form: FormGroup;
    messages: Array<string>;
    validNumbers: Array<number>;
    questionGroup: QuestionGroup;
    questionGroups: Array<QuestionGroup>;
    baseImageAddress: string;
    private userId: string;

    constructor(
        private questionService: QuestionService,
        private questionGroupService: QuestionGroupService,
        private errorHandler: ErrorHandler,
        private router: Router,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder
    ) {
        this.question = new Question();
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.validNumbers = [];
            this.validNumbers.push(1);
            this.validNumbers.push(2);
            this.validNumbers.push(3);

            this.baseImageAddress = AppSettings.apiEndPoint + '/images/';

            var questionGroupId = null;
            if (params['questionGroupId'] && params['questionGroupId'] !== '0') {
                questionGroupId = params['questionGroupId'];
            }

            this.questionGroupService.getQuestionGroups()
                .then(questionGroups => {
                    this.questionGroups = questionGroups;
                    this.questionGroups.forEach(questionGroup => {
                        if (questionGroup.id === questionGroupId) {
                            this.questionGroup = questionGroup;
                        }
                    });
                    this.isDataAvailable = true;

                    if (params['questionId'] && params['questionId'] !== '0') {
                        this.questionService.getQuestion(params['questionId'])
                            .then(question => {
                                this.question = question;
                                this.zoomedImageSrc = this.baseImageAddress + this.question.filename;
                                this.smallImageSrc = this.baseImageAddress + this.question.filename;
                                this.isDataAvailable = true;
                            }
                        )
                        .catch(error => {
                            this.errorHandler.do(error);
                        });
                    } else {
                        this.isDataAvailable = true;
                    }
            }
            )
            .catch(error => {
                this.errorHandler.do(error);
            });
        });
    }

    onFileChange(event) {
        let reader = new FileReader();
        if (event.target.files && event.target.files.length > 0) {
          let file = event.target.files[0];
          reader.readAsText(file, 'UTF-8');

          const formData = new FormData();
          formData.append(file.name, file);

          this.import(formData);
        }
    }

    import(formData: FormData): void {
        this.isDataAvailable = false;

        this.questionService.importImage(formData, this.questionGroup.id)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.messages = null;
                    this.isDataAvailable = true;
                    this.router.navigate(['question/detail', result.data.id, result.data.questionGroupId]);
                } else {
                    this.messages = result.messages;
                    this.isDataAvailable = true;
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
        });
    }

    save(): void {
        this.question.type = this.questionGroup.questionType;
        this.question.questionGroupId = this.questionGroup.id;
        if (this.question.id === undefined) {
            this.insert();
        } else {
            this.update();
        }
    }

    private update(): void {
        this.isDataAvailable = false;
        this.questionService.updateQuestion(this.question)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.messages = null;
                    this.router.navigate(['questions']);
                } else {
                    this.messages = result.messages;
                    this.isDataAvailable = true;
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    private removeProfile(): void {
        this.isDataAvailable = false;
        this.questionService.removeProfile(this.question.id)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.messages = null;
                    location.reload();
                } else {
                    this.messages = result.messages;
                    this.isDataAvailable = true;
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    private rotate(): void {
        this.isDataAvailable = false;
        this.questionService.rotateImage(this.question.id)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.messages = null;
                    location.reload();
                } else {
                    this.messages = result.messages;
                    this.isDataAvailable = true;
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    private insert(): void {
        this.isDataAvailable = false;
        this.questionService.addQuestion(this.question)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.messages = null;
                    this.router.navigate(['questions']);
                } else {
                    this.messages = result.messages;
                    this.isDataAvailable = true;
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    cancel(): void {
        this.router.navigate(['questions']);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/question-detail/question-detail.component.ts